module.exports = __webpack_public_path__ + "img/Frente-47-02 open.6e76a1f5.jpg";